// 9fbef606107a605d69c0edbcd8029e5d
import { call, put, select, delay } from 'redux-saga/effects';
import { setLoaderState } from '@tcp/core/src/components/common/molecules/Loader/container/Loader.actions';
import { getSFLId, getUserLoggedInState } from '../../../account/User/container/User.selectors';
import BAG_PAGE_ACTIONS from './BagPage.actions';
import BAG_SELECTORS from './BagPage.selectors';
import BAGPAGE_CONSTANTS from '../BagPage.constants';
import { getServerErrorMessage } from '../../../../../services/abstractors/CnC/Checkout';
import { moveItemToBagFromSFL } from '../../../../../services/abstractors/CnC/SaveForLater';
import CONSTANTS, { SINGLE_PAGE_CHECKOUT_PAGE } from '../../Checkout/Checkout.constants';
import checkoutSelectors, { isExpressCheckout } from '../../Checkout/container/Checkout.selector';
import { getSetCheckoutStage } from '../../Checkout/container/Checkout.action';
import { imageGenerator } from '../../../../../services/abstractors/SFCC/CartItemTile';
import { setCartLoadingState } from '../../CartItemTile/container/CartItemTile.actions';

export default function* startSflItemDelete({
  payload: { catEntryId, fromMoveToBag, miscInfo, productInfo } = {},
} = {}) {
  let sflId = '';
  const isRegistered = yield select(getUserLoggedInState);
  if (isRegistered) {
    sflId = yield select(getSFLId);
    if (!sflId) {
      sflId = yield select(BAG_SELECTORS.getSflListId);
    }
  } else {
    sflId = yield select(BAG_SELECTORS.getSflListId);
  }
  const getsflItemsList = yield select(BAG_SELECTORS.getsflItemsList);
  const sflItems = yield select(BAG_SELECTORS.getsflItemsList);
  try {
    const res = yield call(
      moveItemToBagFromSFL,
      catEntryId,
      sflId,
      imageGenerator,
      miscInfo,
      productInfo,
      sflItems
    );
    yield put(BAG_PAGE_ACTIONS.setSflData(res));
    if (res.errorResponse && res.errorMessage) {
      const resErr = res.errorMessage[Object.keys(res.errorMessage)[0]];
      yield put(BAG_PAGE_ACTIONS.setCartItemsSflError(resErr));
      yield put(setCartLoadingState(false));
      yield put(setLoaderState(false));
      yield put(BAG_PAGE_ACTIONS.buttonSpinnerLoading(false));
      yield put(BAG_PAGE_ACTIONS.setSflData(getsflItemsList));
    } else if (!fromMoveToBag) {
      yield put(BAG_PAGE_ACTIONS.setSflItemMovedToBag(false));
      yield put(BAG_PAGE_ACTIONS.setSflItemDeleted(true));
      yield put(setCartLoadingState(false));
      yield put(setLoaderState(false));
      yield put(BAG_PAGE_ACTIONS.buttonSpinnerLoading(false));
      yield delay(BAGPAGE_CONSTANTS.ITEM_SFL_SUCCESS_MSG_TIMEOUT);
      yield put(BAG_PAGE_ACTIONS.setSflItemDeleted(false));
    } else {
      yield put(BAG_PAGE_ACTIONS.buttonSpinnerLoading(false));
      yield put(setLoaderState(false));
      yield put(setCartLoadingState(false));
    }
  } catch (err) {
    yield put(setCartLoadingState(false));
    yield put(setLoaderState(false));
    yield put(BAG_PAGE_ACTIONS.buttonSpinnerLoading(false));
    const errorsMapping = yield select(BAG_SELECTORS.getErrorMapping);
    yield put(BAG_PAGE_ACTIONS.setCartItemsSflError(getServerErrorMessage(err, errorsMapping)));
    yield put(BAG_PAGE_ACTIONS.setSflData(getsflItemsList));
  }
}

function* navigateToCheckout(stage, navigation, navigationActions, spcPage) {
  yield put(getSetCheckoutStage(stage));
  navigation.navigate(spcPage ? SINGLE_PAGE_CHECKOUT_PAGE : CONSTANTS.CHECKOUT_ROOT, {
    screenProps: navigation?.state?.params?.screenProps,
  });
}

/**
 * routeForAppCartCheckout component. This is responsible for routing our web to specific page of checkout journey.
 * @param {Boolean} recalc query parameter for recalculation of points
 * @param {Object} navigation for navigating in mobile app
 * @param {Boolean} closeModal for closing addedtoBag modal in app
 * @param {Boolean} orderHasPickup if order has any pickup item
 */
export function* routeForAppCartCheckout(
  navigation,
  closeModal,
  navigationActions,
  orderHasPickup,
  checkoutStage,
  spcPage
) {
  const { hasVenmoReviewPageRedirect } = checkoutSelectors;
  const isExpressCheckoutEnabled = yield select(isExpressCheckout);
  const hasVenmoReviewPage = yield select(hasVenmoReviewPageRedirect);

  if (checkoutStage) {
    yield call(navigateToCheckout, checkoutStage, navigation, navigationActions, spcPage);
  } else if (isExpressCheckoutEnabled || hasVenmoReviewPage) {
    yield call(
      navigateToCheckout,
      CONSTANTS.REVIEW_DEFAULT_PARAM,
      navigation,
      navigationActions,
      spcPage
    );
  } else if (orderHasPickup) {
    yield call(
      navigateToCheckout,
      CONSTANTS.PICKUP_DEFAULT_PARAM,
      navigation,
      navigationActions,
      spcPage
    );
  } else {
    const params = [CONSTANTS.SHIPPING_DEFAULT_PARAM, navigation, navigationActions, spcPage];
    yield call(navigateToCheckout, ...params);
  }
  if (closeModal) {
    const timer = setTimeout(() => {
      closeModal();
      clearTimeout(timer);
    });
  }
}
